export enum EUserType {
    CUSTOMER = 'CUSTOMER',
}
